export const GOUVERNANCE = {
  TWITTER: 'GOUVERNANCE_TWITTER',
  LINKEDIN: 'GOUVERNANCE_LINKEDIN',
  SEEM_MORE: 'GOUVERNANCE_SEEM_MORE',
};
